/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ButtonProps as ChakraButtonProps } from '@chakra-ui/react';

import { colors } from '../foundations';
import { getColorSchemeOrDefault } from '../utils/variants';
import { ThemeComponent } from '@types';

export type ButtonSizes = 'sm' | 'md' | 'lg' | string;
export type ButtonVariants = 'primary' | 'secondary' | 'danger';

export const Button: ThemeComponent<ButtonSizes, ButtonVariants, ChakraButtonProps> = {
  baseStyle: () => ({
    borderRadius: 'sm',
    fontWeight: 'normal',
  }),

  sizes: {
    sm: {
      fontSize: 'sm',
      lineHeight: 'sm',
    },
    md: {
      fontSize: 'md',
      lineHeight: 'md',
    },
    lg: {
      fontSize: 'lg',
      lineHeight: 'lg',
    },
  },

  variants: {
    primary: ({ colorScheme }) => {
      const colorSchemaDefault = getColorSchemeOrDefault<keyof typeof colors>({
        colorScheme: colorScheme as keyof typeof colors,
        colorSchemeDefault: 'primary',
      });

      return {
        background: `${colorSchemaDefault}.500`,
        color: 'white',
        _hover: {
          background: `${colorSchemaDefault}.700`,
          _disabled: {
            background: `${colorSchemaDefault}.300`,
          },
        },
        _focus: {
          boxShadow: `0px 0px 0px 3px ${colors[colorSchemaDefault]?.[200]}`,
        },
        _disabled: {
          background: `${colorSchemaDefault}.300`,
          cursor: 'not-allowed',
        },
      };
    },
    secondary: ({ colorScheme }) => {
      const colorSchemaDefault = getColorSchemeOrDefault<keyof typeof colors>({
        colorScheme: colorScheme as keyof typeof colors,
        colorSchemeDefault: 'ui',
      });

      return {
        background: `${colorSchemaDefault}.50`,
        border: 'sm',
        borderColor: `${colorSchemaDefault}.200`,
        color: `${colorSchemaDefault}.700`,
        textStyle: 'custom',
        _hover: {
          background: `${colorSchemaDefault}.100`,
        },
        _focus: {
          boxShadow: `0px 0px 0px 3px ${colors[colorSchemaDefault]?.[200]}`,
        },
        _disabled: {
          color: `${colorSchemaDefault}.500`,
          cursor: 'not-allowed',
        },
      };
    },
    danger: ({ colorScheme }) => {
      const colorSchemaDefault = getColorSchemeOrDefault<keyof typeof colors>({
        colorScheme: colorScheme as keyof typeof colors,
        colorSchemeDefault: 'supportA',
      });

      return {
        background: `${colorSchemaDefault}.500`,
        color: 'white',
        _hover: {
          background: `${colorSchemaDefault}.600`,
          _disabled: {
            background: `${colorSchemaDefault}.300`,
          },
        },
        _focus: {
          boxShadow: `0px 0px 0px 3px ${colors[colorSchemaDefault]?.[200]}`,
        },
        _disabled: {
          cursor: 'not-allowed',
          background: `${colorSchemaDefault}.300`,
          borderColor: `${colorSchemaDefault}.300`,
        },
      };
    },
  },

  defaultProps: {
    size: 'md',
    variant: 'primary',
    colorScheme: null,
  },
};
